"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RecipientRecordHelper = void 0;
const PuzzleRecord_1 = require("./PuzzleRecord");
const moment = require("moment").default || require("moment");
// Helper class for recipient records
class RecipientRecordHelper {
    /**
     * Convert internal interface to JSON
     *
     * @param i
     * @constructor
     */
    static IToJ(i) {
        // if null, return it
        if (i == null) {
            return i;
        }
        let j = {
            id: i.id,
            name: i.name,
            email: i.email,
            authCode: i.authCode,
            createdAtEpochTs: i.createdAt.valueOf(),
            isViewed: i.isViewed,
            lastViewedAtEpochTs: (i.lastViewedAt == null ? null : i.lastViewedAt.valueOf()),
            isRedeemed: i.isRedeemed,
            redeemedAtEpochTs: (i.redeemedAt == null ? null : i.redeemedAt.valueOf()),
            timeToComplete: i.timeToComplete,
            puzzleId: i.puzzleId,
            puzzleSavePoint: i.puzzleSavePoint
        };
        // convert assigned puzzle as well
        if (!(typeof i.puzzleAssigned === 'undefined')) {
            j.puzzleAssigned = PuzzleRecord_1.PuzzleRecordHelper.IToJ(i.puzzleAssigned);
        }
        return j;
    }
    /**
     * Convert JSON to internal interface
     * @param j
     * @constructor
     */
    static JToI(j) {
        // if null, return it
        if (j == null) {
            return j;
        }
        let i = {
            id: j.id,
            name: j.name,
            email: j.email,
            authCode: j.authCode,
            createdAt: moment(j.createdAtEpochTs),
            isViewed: j.isViewed,
            lastViewedAt: (j.lastViewedAtEpochTs == null ? null : moment(j.lastViewedAtEpochTs)),
            isRedeemed: j.isRedeemed,
            redeemedAt: (j.redeemedAtEpochTs == null ? null : moment(j.redeemedAtEpochTs)),
            timeToComplete: j.timeToComplete,
            puzzleId: j.puzzleId,
            puzzleSavePoint: j.puzzleSavePoint
        };
        // convert assigned puzzle as well
        if (!(typeof j.puzzleAssigned === 'undefined')) {
            i.puzzleAssigned = PuzzleRecord_1.PuzzleRecordHelper.JToI(j.puzzleAssigned);
        }
        return i;
    }
    /**
     * Convert array of internal interface to array of JSON
     * @param is
     * @constructor
     */
    static IToJArray(is) {
        // if null, return it
        if (is == null) {
            return is;
        }
        let js = [];
        for (let i = 0; i < is.length; i++) {
            js.push(RecipientRecordHelper.IToJ(is[i]));
        }
        return js;
    }
    /**
     * Convert array of JSON to array of internal interface
     * @param js
     * @constructor
     */
    static JToIArray(js) {
        // if null, return it
        if (js == null) {
            return js;
        }
        let is = [];
        for (let i = 0; i < js.length; i++) {
            is.push(RecipientRecordHelper.JToI(js[i]));
        }
        return is;
    }
}
exports.RecipientRecordHelper = RecipientRecordHelper;
//# sourceMappingURL=RecipientRecord.js.map